module.exports = __webpack_public_path__ + "img/correspondent-logo--white-text.e5f0797c.png";